<template>
  <div class="bargain-active-index">

    <div class="d-b-c">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label=""><el-input v-model="searchForm.search" placeholder="请输入主播名称"></el-input></el-form-item>
        <el-form-item>
          <el-select size="small" placeholder="请选择" v-model="searchForm.aduit_value">
            <el-option label="全部" value=""></el-option>
            <el-option label="待审核" value="3"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核不通过" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="anchor_id" label="主播ID"></el-table-column>
          <el-table-column prop="anchor_name" label="主播名称"></el-table-column>
          <el-table-column prop="anchor_data_id" label="主播抖音id"></el-table-column>
          <el-table-column label="主播头像">
              <template slot-scope="scope">
                  <a :href="scope.row.image_url" target="_blank"><img v-img-url="scope.row.image_url" width="30%" /></a>
              </template>
          </el-table-column>
           <el-table-column prop="mobile" label="主播手机号"></el-table-column>
          <el-table-column label="二维码">
            <template slot-scope="scope">
                <a :href="scope.row.img_url" target="_blank"><img v-img-url="scope.row.img_url" width="30%" /></a>
            </template>
          </el-table-column>
          <el-table-column prop="status_text" label="状态" ></el-table-column>
          <el-table-column prop="time_text" label="预告时间"></el-table-column>
          <el-table-column prop="name" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="auditClick(scope.row.notice_id,scope.row.status)" type="text" size="small">审核</el-button>
              <!-- <el-button @click="deleteNotice(scope.row.notice_id)" type="text" size="small">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>

    </div>

    <!-- 审核 -->
    <el-dialog
      title="提示"
      :visible.sync="audit_status"
      width="30%"
      >
      <el-radio-group v-model="status">
        <el-radio  label="3"  @change="changeStatus(3)">待审核</el-radio>
        <el-radio  label="1"  @change="changeStatus(1)">审核通过</el-radio>
        <el-radio  label="2"  @change="changeStatus(2)">审核不通过</el-radio> 
      </el-radio-group>
     
      <span slot="footer" class="dialog-footer">
      <el-button @click="audit_status = false">取 消</el-button>
      <el-button type="primary" @click="auditNotice()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AnchorApi from "@/api/anchor.js";
export default {
  components: {},
  data() {
    return {
      /*搜索表单对象*/
      searchForm: {},
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      commentData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      // 审核框显示
      audit_status:false,
      status:'',
      select_status : '',
      aduit_value:'',
      /*审核状态*/
      options: [{
          value: 'all',
          label: '全部'
      }, {
        value: 'will',
        label: '待审核'
      }, {
        value: 'success',
        label: '审核通过'
      }, {
        value: 'fail',
        label: '审核不通过'
      }],
      value: 'all',
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
    };
  },
  created() {
    /*获取文章列表*/
    this.getTableList();
  },
  methods: {
    /*查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    /*获取文章列表*/
    getTableList() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      AnchorApi.anchorNoticeList(Params, true)
        .then((data) => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    // 审核状态
    auditClick(res,item){
      this.select_id = res;
      this.status = item.toString();
      this.audit_status = true;
    },
     // 修改状态
    changeStatus(res){
      this.select_status = res
    },
    // 审核证书
    auditNotice(){
      let self = this;
      let Params = {};
      Params.notice_id = this.select_id;
      Params.status = this.select_status;
      AnchorApi.auditNotice(Params, true)
        .then(data => {
          self.audit_status = false;
          self.getTableList();
        })
        .catch(error => {});
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getData();
    },

  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/anchor/notice/index.vue